import {
    CSSProperties,
    useMemo,
} from 'react'

import {
    ReactComponent as OrangeWarningIcon,
} from 'app/shared-components/images/icons/warning_orange.svg'
import {
    ReactComponent as RedWarningIcon,
} from 'app/shared-components/images/icons/warning_icon.svg'
import {
    IconType,
} from 'app/enums/common.enums'

import TooltipWrapper from 'app/shared-components/Tooltip/TooltipWrapper'
import useStyles from './TextIcon.styles'

const EMPTY_OBJECT = {}

export default function TextIcon({
    type,
    value,
    tooltip,
    textStyles = EMPTY_OBJECT,
}: Readonly<{
    type?: IconType,
    value: string,
    tooltip?: string,
    textStyles?: CSSProperties,
}>) {
    const {
        classes, cx,
    } = useStyles({
        type,
    })

    const icon = useMemo(() => {
        switch (type) {
        case IconType.RedWarning:
            return <RedWarningIcon className={classes.icon} />
        case IconType.OrangeWarning:
            return <OrangeWarningIcon className={classes.icon} />
        default:
            return null
        }
    }, [
        classes.icon,
        type,
    ])

    return (
        <div className={classes.cell}>
            <div
                className={cx(
                    classes.text,
                    classes[type],
                )}
                style={textStyles}
            >
                {value}
            </div>
            <TooltipWrapper
                value={tooltip}
                ownTooltipProps={{
                    enterDelay: 100,
                    placement: 'bottom',
                }}
                className={classes.tooltip}
            >
                {icon}
            </TooltipWrapper>
        </div>
    )
}
